import React from "react";

const Footer: React.FC = () => {
    return (
        <footer className="w-full py-6 px-4 mt-auto border-t border-gray-200">
            <div className="max-w-7xl mx-auto text-center">
                <div className="text-sm text-gray-600">
                    <a
                        href="https://www.passio.ai/passio-ai-tools-license-terms"
                        className="text-primary-600 hover:text-primary-700 hover:underline"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Terms & Conditions
                    </a>
                    <span className="mx-2">•</span>
                    <a
                        href="https://www.passio.ai/privacy-policy"
                        className="text-primary-600 hover:text-primary-700 hover:underline"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Privacy Policy
                    </a>
                </div>
                <div className="mt-2 text-xs text-gray-500">
                    © {new Date().getFullYear()} Passio AI. All rights reserved.
                </div>
            </div>
        </footer>
    );
};

export default Footer; 